module.exports = __webpack_public_path__ + "static/img/list-item-3.ff66f0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/list-item-3.png
// module id = dHj4
// module chunks = 1